import {Routes} from '@angular/router';
import {AuthGuard} from '@core/services/auth-guard.service';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';


export const spreadsheetRoutes: Routes = [
  // {
  //   path     : 'spread-sheet',
  //   component: PlatformLinkCreatorComponent,
  //   canActivate: [AuthGuard]
  // },
  {
    path     : 'logs/job-data-analysis',
    component: PlatformLinkCreatorComponent
  }
];
